import React, { useEffect, useState, useRef } from "react";

const BlogPopup = (props) => {
  const [detail, setDetail] = useState();
  const modalRef = useRef(null);

  useEffect(() => {
    if (props.data) {
      setDetail(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    if (detail) {
    }
  }, [detail]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        props.onClick();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props.onClick]);

  if (!detail) return null;

  return (
    <div
      className={`modal commom-modal blog-modal fade ${
        props.showBoolean ? "show showModal" : "hide hideModal"
      }`}
      id="blogModal"
      tabindex="-1"
      aria-hidden="false"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <button
            className="modal-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref={modalRef}
            onClick={props.onClick}
          >
            <div className="bi bi-x"></div>
          </button>
          <div className="modal-body">
            <h2 className="blog-title text-black">{detail.title}</h2>
            <div className="blog-thumb">
              <img
                src={`${process.env.REACT_APP_ASSET_KEY}${detail.displayImg}`}
                alt="blog featured image"
                className="w-100"
              />
            </div>
            <ul className="blog-meta">
              <li>{detail.date}</li>
              <li>{detail.writer}</li>
            </ul>
            <div className="blog-disc">
              <h4 className="text-xl">{detail.heading}</h4>
              <p>{detail.subHeading}</p>
              <p>{detail.intro}</p>
              <blockquote>
                {detail.quote}
                <cite> - {detail.writer}</cite>
              </blockquote>
              <p>{detail.description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPopup;
